module.exports = __webpack_public_path__ + "static/media/ic-office-2.b5436c6f.svg";